import React from 'react';
import { Camera } from 'lucide-react';

import UIStrings from '@/Utils/UIStrings';

import CTMonitoringFunctionalityDisabled from './CTMonitoringFunctionalityDisabled';

function CTMonitoringWebcamStub(): React.JSX.Element {
    return (
        <CTMonitoringFunctionalityDisabled
            icon={<Camera className="text-muted-foreground size-6" aria-hidden />}
            message={UIStrings.WebcamDisabled}
            className="h-52"
        />
    );
}

export default CTMonitoringWebcamStub;
